












import {ChartDataTemplate, WConfTpl, WidgetDefinition} from '@/components/widgets/WidgetFather'
import {defineComponent, reactive} from "@vue/composition-api"
import {getStoredProcedure} from "@/data/repos/storedProcedure"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {extractParams} from "@/components/widgets/hd/hdCommon"

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.Custom(),
    widget: "HDTopFiveFaultsForMonthToDate",
    title: "Top 5 faults for month to date",
    cType: "mscolumn2d",
    _description: "",
    params: {
      // hdPPMRepairAll: {...WParamTpl.hdPPMRepairAll(), _order: 2},
      // hdCategory: {...WParamTpl.hdCategory(), _order: 3},
      // hdContractor: {...WParamTpl.hdContractor(), _order: 4},
    },
  }
}

async function dataFetcher(params: any) {
  const p = extractParams(params)
  return filter(await getStoredProcedure(
    'AnalyticsCenter',
    'widget_Top5FaultTypes',
    [p.userId, p.month, p.year]))
}

function getChartDataConfig() {
  return reactive({
      ...ChartDataTemplate(),
      yAxisName: "Number of jobs",
      xAxisName: "Faults",
      showLabels: "1",
      rotateLabels: "0",
    },
  )
}

function chartDSTemplate() {
  return {
    categories: [],
    dataset: [],
  }
}

async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
  config && (chartDataConfig.subCaption = getTitle(config.params))
}

function getTitle(params: any) {
  const p = extractParams(params)
  return ""
}

export default defineComponent({
  props: {config: Object},
  components: {FusionChartWidget},
  setup(props, context) {
    context.emit("config-update", config())

    function chartClickCallback() {
      // const componentArgs = extractParams(props.config && props.config.params)
      // bus.$emit('chartPopup', {
      //   title: "Completed PM Jobs for Month to Date: " + getTitle(props.config && props.config.params),
      //   component: () => import('@/components/drilldowns/JobsAllocatedInAMonthPPMJobsCompletedDrillDown.vue'),
      //   componentArgs,
      // })
    }

    return {dataFetcher, getChartDataConfig, configChangeCallback, chartClickCallback, chartDSTemplate}
  },
})

function filter(data: Array<{ Code: string, CodeDescription: string, OptionFilter: string, Value: number }>): any {
  const categories = new Array<{ label: string }>()
  const currentDataset = new Array<{ value: number, additionalValue: number }>()
  const previousDataset = new Array<{ value: number, additionalValue: number }>()
  for (const item of data) {
    categories.push({label: item.CodeDescription})
    currentDataset.push({value: item.Value, additionalValue: 777})
    previousDataset.push({value: parseFloat(item.OptionFilter), additionalValue: 666})
  }
  return {
    categories: [
      {
        category: categories,
      },
    ],
    dataset: [
      {
        seriesName: 'Previous Year',
        color: '#4A47EB',
        data: previousDataset,
      },
      {
        seriesName: 'This Year',
        color: '#201F7A',
        data: currentDataset,
      },
    ],
  }
}
